import React from 'react';
import styled from 'styled-components';
import { List, Divider } from '@material-ui/core';
import { useSelector } from 'react-redux';

import WorkspaceSelector from './WorkspaceSelector';
import SectionHeader from './SectionHeader';
import NavItem from './NavItem';
import { generateUrlForWorkspace } from '../Workspace/common';
import { DROPS, hasFeatureFlag } from '../util/featureFlags';

import {
    Dashboard as DashboardIcon,
    Settings as SettingsIcon,
    AddToQueue as AddIcon,
    People as AccountIcon,
    ViewModule as WorkspacesIcon,
    GetApp as DownloadIcon,
    Timeline as TimelineIcon,
    TrendingDown as TrafficIcon,
    ReportProblem as IssuesIcon,
    ShowChart as DropsIcon,
} from '@material-ui/icons';
import LinkOffIcon from '@material-ui/icons/LinkOff';

const WsSelectorWrap = styled.div`
    margin: 10px 8px 16px;
`;

const StyledDivider = styled(Divider)`
    border-color: rgba(148, 163, 184, 0.25);
`;

function wsPath(base, workspaceNumber) {
    if (!Number.isFinite(Number(workspaceNumber))) return undefined;
    const root = generateUrlForWorkspace(workspaceNumber);
    return base ? `${root}${base}` : root;
}

export default function NavItems() {
    const ws = useSelector((s) => s.workspaces?.current);
    const workspaceNumber = ws?.seqNumber;
    const hasWs = Number.isFinite(Number(workspaceNumber));
    const drops = useSelector((s) => hasFeatureFlag(s.login.userDetails, DROPS));

    return (
        <>
            <List disablePadding>
                <NavItem
                    to="/workspaces"
                    exact
                    icon={<WorkspacesIcon />}
                    label="All Workspaces"
                    isActive={(m) => !!m && m.isExact}
                />
            </List>

            <WsSelectorWrap aria-label="Select workspace">
                <WorkspaceSelector />
            </WsSelectorWrap>

            {hasWs && (
                <>
                    <StyledDivider />
                    <SectionHeader>CURRENT</SectionHeader>
                    <List disablePadding>
                        <NavItem
                            to={wsPath('', workspaceNumber)}
                            exact
                            icon={<DashboardIcon />}
                            label="Dashboard"
                            isActive={(m) => !!m && m.isExact}
                            nested
                        />
                        <NavItem
                            to={wsPath('/trends', workspaceNumber)}
                            icon={<TimelineIcon />}
                            label="Trends"
                            nested
                        />
                        <NavItem
                            to={wsPath('/traffic', workspaceNumber)}
                            icon={<TrafficIcon />}
                            label="Losing Traffic"
                            nested
                        />
                        <NavItem
                            to={wsPath('/issues', workspaceNumber)}
                            icon={<IssuesIcon />}
                            label="Issues"
                            nested
                        />
                        {drops && (
                            <NavItem
                                to={wsPath('/drops', workspaceNumber)}
                                icon={<DropsIcon />}
                                label="Drops"
                                nested
                            />
                        )}
                        <NavItem
                            to={wsPath('/broken-links', workspaceNumber)}
                            icon={<LinkOffIcon />}
                            label="Broken Links"
                            nested
                        />
                        <NavItem
                            to={wsPath('/add-url', workspaceNumber)}
                            icon={<AddIcon />}
                            label="Add Recommendations"
                            nested
                        />
                        <NavItem
                            to={wsPath('/exports', workspaceNumber)}
                            icon={<DownloadIcon />}
                            label="Exports"
                            nested
                        />
                        <NavItem
                            to={wsPath('/admin', workspaceNumber)}
                            icon={<SettingsIcon />}
                            label="Workspace Settings"
                            nested
                        />
                    </List>
                </>
            )}

            <StyledDivider />
            <SectionHeader>User Settings</SectionHeader>
            <List disablePadding>
                <NavItem to="/account" icon={<AccountIcon />} label="Account" exact />
            </List>
        </>
    );
}
